import {Game} from "@game/game";
import {LocalisedTypography} from "@components/localisation/LocalisedTypography";
import {ChangeEventHandler, CSSProperties, useState} from "react";
import {THEME} from "@components/core/theme";

const styles: Record<string, CSSProperties> = {
    ...THEME,
    alert: {
        ...THEME.text,
        backgroundColor: "red",
        borderRadius: 9,
        color: "white",
        fontWeight: "bold",
        minWidth: 18,
        textAlign: "center"
    },
    contents: {
        display: "flex",
        flexDirection: "column",
        margin: 4
    }
};
interface IUserInvitesPanel {
    game: Game
}

export function UserInvitesPanel({game}: IUserInvitesPanel) {
    const [input, setInput] =
        useState<Record<string, string>>({})
    const handleAddInvite = async () => {
        game.addInvite(input.host, input.username).then(() => {
            setInput({});
        });
    };
    const handleInputChange = (key: string):ChangeEventHandler<HTMLInputElement> =>
        ({target}) =>
            setInput(input => ({...input, [key]: target.value}));

    return (
        <div>
            <div style={styles.labelledInput}>
                <div style={styles.label}>
                    <LocalisedTypography content="InvitesUsername"/>
                </div>
                <input onChange={handleInputChange("username")}
                       style={styles.input} value={input["username"] || ""}/>
            </div>
            <div style={styles.labelledInput}>
                <div style={styles.label}>
                    <LocalisedTypography content="InvitesHost"/>
                </div>
                <input onChange={handleInputChange("host")}
                       style={styles.input} value={input["host"] || ""}/>
            </div>
            <div style={styles.labelledInput}>
                <div style={styles.label}/>
                <button disabled={!input.host || !input.username} onClick={handleAddInvite}
                        style={styles.button}>
                    <LocalisedTypography content="InvitesAdd"/>
                </button>
            </div>
        </div>
    );
}